import { render, staticRenderFns } from "./CDNFreInput.vue?vue&type=template&id=08abd41f&scoped=true&"
import script from "./CDNFreInput.vue?vue&type=script&lang=js&"
export * from "./CDNFreInput.vue?vue&type=script&lang=js&"
import style0 from "./CDNFreInput.vue?vue&type=style&index=0&id=08abd41f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08abd41f",
  null
  
)

export default component.exports